<template>
    <b-container fluid class="py-3">
        <b-row>
            <b-col>
                <!-- {{ items }} -->
                <Tableview :value="items" :paginator="true" class="p-datatable-gridlines" :rows="10" :rowHover="true"
                    filterDisplay="menu" :loading="loading" responsiveLayout="scroll" :columns="headers"
                    :globalFilterFields="globalFilterFields" :filters="filters" selectionMode="single"
                    dataKey="RowNumber" @row-click="RowClick">
                    <template v-slot:IssueStatus="{ data }">
                        <OrangeStatus name="Pending" v-if="data.IssueStatus == 0" />
                        <GreenStatus name="Issued" v-if="data.IssueStatus == 1" />
                        <RedStatus name="Closed" v-if="data.IssueStatus == 2" />
                    </template>
                    <template v-slot:action="{ data }">
                        <span v-if="data.IssueStatus == 0">
                            <Button icon="pi pi-ellipsis-v" class="p-button-rounded editicon p-button-text"
                                @click="toggle($event, data)" />
                        </span>
                    </template>
                </Tableview>
            </b-col>
        </b-row>
    </b-container>

    <ItemAllocationPopup v-model:showIOLDialog="showIOLDialog" v-if="showIOLDialog" showitems="allocate"
        @closepopup=isClear :PatientDetails="PatientDetails" />

    <Menu ref="menu" id="overlay_menu" :model="ActionList" :popup="true" />

    <CancelSuccessfully :content="ObjAction.SuccessPopupContent" :visible="ObjAction.SuccessModel"
        @ok="cancelclose()" />

    <CancelConfirmation :Editmodel="ObjAction.CancelModel" @yes="CancelStatuschange()"
        @no="ObjAction.CancelModel = false" :header="ObjAction.ConfirmPopupName"
        :content="ObjAction.ConfirmPopupContent" />

</template>

<script lang="ts">
import { defineComponent, ref, computed, onMounted, watch } from 'vue'
import { useRoute, useRouter } from "vue-router";
import moment from "moment";

import Tableview from "../../../../../components/FormComponents/Table.vue";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import ItemAllocationPopup from "../../../../../modules/Inventory/pages/Transaction/PatientIssue/ItemAllocationPopup.vue"
import CancelConfirmation from "../../../../../components/FormComponents/CancelConfirmation.vue";
import CancelSuccessfully from "../../../../../components/FormComponents/CancelSuccessfully.vue";
import PatientIssueService from "../../../../../modules/Inventory/Service/PatientIssueService"
import ConfirmPopup from 'primevue/confirmpopup';

export default defineComponent({
    components: {
        Tableview,
        ItemAllocationPopup,
        CancelConfirmation,
        CancelSuccessfully
    },
    props: {
        FilterObj: {
            type: Object,
            default: {}
        },
    },
    setup(props, { emit }) {

        const route = useRoute();

        const loading = ref(false)
        const showIOLDialog = ref(false);
        let items = ref([]);
        let PatientDetails = ref({})

        let SessionUserData = localStorage.getItem("UsersData");
        let usersData;
        if (SessionUserData !== null) {
            usersData = JSON.parse(SessionUserData);
        }

        const headers = [
            {
                header: "#",
                field: "RowNumber",
                class: 'filterdisplaynone'
            },
            {
                header: "Issue status",
                field: "",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
                slot: "IssueStatus",
                fieldDisplay: "false",
            },
            {
                header: "UIN",
                field: "uin",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
                bodyclass: 'boldclass',
            },
            {
                header: "MRN No",
                field: "mrno",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
                bodyclass: 'boldclass',
            },
            {
                header: 'Patient Name',
                field: 'patientName',
                filterTemplate: 'MultiSelect',
                ShowMactchMode: false,
            },
            {
                header: 'Patient Type',
                field: 'patientType',
                filterTemplate: 'MultiSelect',
                ShowMactchMode: false,
            },
            {
                header: 'Surgery Name',
                field: 'surgery',
                filterTemplate: 'MultiSelect',
                ShowMactchMode: false,
                class: 'width150'
            },
            {
                header: 'Required Lens Diaptor',
                field: 'iolPower',
                filterTemplate: 'MultiSelect',
                ShowMactchMode: false,
            },

            {
                header: 'Allocated Lens Diaptor',
                field: 'SizeName',
                filterTemplate: 'MultiSelect',
                ShowMactchMode: false,
            },
            {
                header: 'Item',
                field: 'ItemName',
                filterTemplate: 'MultiSelect',
                ShowMactchMode: false,
            },
            {
                header: 'LOT No',
                field: 'BarCode',
                filterTemplate: 'MultiSelect',
                ShowMactchMode: false,
            },
            {
                field: "action",
                header: "",
                slot: "action",
                frozencolumn: true,
                sortable: false,
                hide: false,
                class: "filterdisplaynone last-column-position",
                fieldDisplay: "false",
            },
        ];

        const menu = ref();
        let actionnCancel = ref(false);

        let AllocationId = ref(0);

        let ObjAction = ref({
            ConfirmPopupName: "",
            ConfirmPopupContent: "",
            CancelModel: false,
            SuccessPopupContent: "",
            SuccessModel: false,
        })

        const toggle = (event, data) => {
            debugger;
            actionnCancel.value = data.IssueStatus == 1 || data.IssueStatus == 2 ? false : true
            AllocationId.value = data.Id;

            menu.value.toggle(event);
        }

        const ActionList = ref([
            {
                items: [
                    {
                        label: "Cancel",
                        icon: "deleteicon pi pi-times",
                        visible: actionnCancel,
                        command: async () => {
                            Cancel();
                        },
                    },
                ],
            },
        ]);


        function Cancel() {
            debugger;
            ObjAction.value.ConfirmPopupName = "Confirm cancel!"
            ObjAction.value.ConfirmPopupContent = "Do you want to cancel"
            ObjAction.value.CancelModel = true;
        }

        const CancelStatuschange = async () => {
            debugger;
            try {
                const response = await PatientIssueService.IOLAllocationCancel(
                    AllocationId.value
                );

                let message = response["ErrorInfo"].ErrorCode;

                if (message == null) {
                    ObjAction.value.CancelModel = false;
                    ObjAction.value.SuccessPopupContent = "Cancelled successfully"
                    ObjAction.value.SuccessModel = true;

                } else {
                    alert("Somthing went wrong");
                }
            } catch (error) {
                console.log(error);
            }
        };

        function cancelclose() {
            ObjAction.value.SuccessModel = false;
            LoadAllocatedTable();
        }

        const filters = {
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            Code: { value: null, matchMode: FilterMatchMode.IN, options: items },
            TemplateInfo: { value: null, matchMode: FilterMatchMode.IN, options: items },
        };

        const filteredColumns = computed(() => {
            return headers.filter((col) => col.field !== "id");
        });

        const globalFilterFields = ref(headers.map((col) => col.field));

        onMounted(() => {
            ReadyFunction();
        });

        const ReadyFunction = () => {
            debugger;
            LoadAllocatedTable();
        }

        interface Obj {
            HospitalId: number | 0;
            BranchId: number | 0;
            StoreId: number | 0;
            Date: string
        }

        const Obj = ref<Obj>({
            HospitalId: usersData.OrganizationId,
            BranchId: Number(route.query.BranchId),
            StoreId: Number(route.query.Id),
            Date: moment().format("YYYY-MM-DD"),
        })

        const LoadAllocatedTable = async (): Promise<void> => {
            debugger;
            try {

                const response = await PatientIssueService.GetIOLAllocatedItems(Obj.value);

                let RowNumber = 0;
                items.value = response["result"].map((item) => {
                    RowNumber = RowNumber + 1
                    item.RowNumber = RowNumber;
                    return item;
                });

            } catch (error) {
                console.error('Error loading allocated item table:', error);
            }
        }

        watch(
            () => [props.FilterObj.Date],
            ([newFilterObj]) => {
                debugger;
                if (newFilterObj) {
                    Obj.value.Date = newFilterObj;
                    LoadAllocatedTable();
                }
            },
            { immediate: true }
        );

        function RowClick(Obj) {
            // PatientDetails.value = Obj.data;
            // showIOLDialog.value = true;
        }

        function isClear() {
            showIOLDialog.value = false;
        }

        return {
            items,
            loading,
            filteredColumns,
            globalFilterFields,
            headers,
            filters,
            RowClick,
            showIOLDialog,
            isClear,
            PatientDetails,
            toggle,
            ActionList,
            menu,
            ObjAction,
            CancelStatuschange,
            cancelclose
        }
    }

})
</script>

<style lang="scss" scoped></style>